import { Box, Grid, StatusIndicator } from "@amzn/awsui-components-react";
import { RecommendationItem, ServiceItem } from "../../calcBusterTypes";
import { USDollar } from "../../util";
import RecommendationStatuses from "../../summary/recommendation-statuses/RecommendationStatuses";

export const COLUMN_DEFINITIONS = [
  {
    id: "id",
    header: "Estimate id",
    cell: (item: ServiceItem) => item.id,
    sortingField: "id",
    isRowHeader: true,
  },
  {
    id: "serviceCode",
    header: "Service Code",
    cell: (item: ServiceItem) => (
      <Grid gridDefinition={[{ colspan: 10 }, { colspan: 2 }]}>
        <div>{item.serviceCode}</div>
        {/* <div>
          <Service item={item} />
        </div> */}
      </Grid>
    ),
    sortingField: "serviceCode",
  },
  {
    id: "description",
    header: "Description",
    cell: (item: ServiceItem) => item.description,
  },
  {
    id: "group",
    header: "Group",
    cell: (item: ServiceItem) => item.group,
    sortingField: "group",
  },
  {
    id: "region",
    header: "Region",
    cell: (item: ServiceItem) => item.region,
    sortingField: "region",
  },
  {
    id: "recommendation",
    header: "Recommendations",
    cell: (item: ServiceItem) => {
      const serviceRecommendations = getServiceRecommendations(item);
      return serviceRecommendations.length > 0 ? (
        RecommendationStatuses(serviceRecommendations)
      ) : (
        <StatusIndicator type="success">No Recommendations</StatusIndicator>
      );
    },
  },
  {
    id: "monthlyCost",
    header: "Monthly Cost",
    cell: (item: ServiceItem) => USDollar.format(item.serviceCost),
    sortingField: "serviceCost",
  },
];

export function EmptyState({
  title,
  subtitle,
  action,
}: {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}) {
  return (
    <Box textAlign="center" color="inherit">
      <Box variant="strong" textAlign="center" color="inherit">
        {title}
      </Box>
      <Box variant="p" padding={{ bottom: "s" }} color="inherit">
        {subtitle}
      </Box>
      {action}
    </Box>
  );
}

export function getMatchesCountText(count: number) {
  return count === 1 ? `1 match` : `${count} matches`;
}

const pageSizePreference = {
  title: "Select page size",
  options: [
    { value: 10, label: "10 resources" },
    { value: 20, label: "20 resources" },
  ],
};

const visibleContentPreference = {
  title: "Select visible content",
  options: [
    {
      label: "Main properties",
      options: COLUMN_DEFINITIONS.map(({ id, header }) => ({
        id,
        label: header,
        editable: id !== "id",
      })),
    },
  ],
};

export const collectionPreferencesProps = {
  pageSizePreference,
  visibleContentPreference,
  cancelLabel: "Cancel",
  confirmLabel: "Confirm",
  title: "Preferences",
};

const getServiceRecommendations = (
  service: ServiceItem
): RecommendationItem[] => {
  const components = service.components ?? [];
  const componentsWithRecommendations = components.filter(
    (c) => c.optimizations?.recommendations
  );
  const recommendations = componentsWithRecommendations
    .map((c) => c.optimizations!.recommendations!)
    .flat();

  return recommendations;
};

interface ColumnDisplayProperty {
  id: string;
  visible: boolean;
}

export function convertToColumnProps(visibleIds: string[], allIds: string[]) {
  const columnProps = [];
  for (const id of allIds) {
    if (visibleIds.includes(id)) {
      columnProps.push({ id: id, visible: true });
    } else {
      columnProps.push({ id: id, visible: false });
    }
  }
  return columnProps as readonly ColumnDisplayProperty[];
}
